import { shareColumnsExtend, shareFormColumnsExtend } from '../share';

const entityColumns = {
  url: {
    model_name: 'ActiveStorage::Blob',
    column_type: 'string',
    label_key_path: 'activeStorage/blob.url',
  },
  signed_id: {
    model_name: 'ActiveStorage::Blob',
    column_type: 'string',
    label_key_path: 'activeStorage/blob.signedId',
  },
  content_type: {
    model_name: 'ActiveStorage::Blob',
    column_type: 'string',
    label_key_path: 'activeStorage/blob.contentType',
  },
  filename: {
    model_name: 'ActiveStorage::Blob',
    column_type: 'string',
    label_key_path: 'activeStorage/blob.filename',
  },
  byte_size: {
    model_name: 'ActiveStorage::Blob',
    column_type: 'integer',
    label_key_path: 'activeStorage/blob.byteSize',
  },
  id: {
    model_name: 'ActiveStorage::Blob',
    column_type: 'id',
    label_key_path: 'activeStorage/blob.id',
  },
  created_at: {
    model_name: 'ActiveStorage::Blob',
    column_type: 'datetime',
    label_key_path: 'activeStorage/blob.createdAt',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
